import { render, staticRenderFns } from "./fieldTextarea.vue?vue&type=template&id=216bf263&"
import script from "./fieldTextarea.vue?vue&type=script&lang=js&"
export * from "./fieldTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports